/*
*  This file contains the list of table headers used throughout the application.
*/

export const BUILDING_TABLE_HEADERS = [
    {
        title: "Building Name",
        alignItemTo: "left",
        width: 400
    },
    {
        title: "Address",
        alignItemTo: "left",
        width: 750
    },
    {
        title: "Actions",
        alignItemTo: "left",
        width: 150
    },
];


export const RENTAL_PROPERTY_TABLE_HEADERS = [
    {
        title: 'Property Name',
        alignItemTo: 'left',
        width: 300,
    },
    {
        title: 'Building Name',
        alignItemTo: 'left',
        width: 300,
    },
    {
        title: 'Property Address',
        alignItemTo: 'left',
        width: 600,
    },
    {
        title: 'Actions',
        alignItemTo: 'left',
        width: 150
    },
];

export const TENANTS_TABLE_HEADERS = [
    {
        title: 'Name',
        alignItemTo: 'left',
        width: 400,
    },
    {
        title: 'Contact',
        alignItemTo: 'left',
        width: 400,
    },
    {
        title: 'Entry Date',
        alignItemTo: 'left',
        width: 200,
    },
    {
        title: 'Propety',
        alignItemTo: 'left',
        width: 600,
    },
    {
        title: 'Rent Amount',
        alignItemTo: 'left',
        width: 300,
    },
    {
        title: 'Actions',
        alignItemTo: 'left',
        width: 150
    },
];

export const INVOICE_TABLE_HEADERS = [
    {
        title: '',
        alignItemTo: 'left',
        width: 150
    },

    {
        title: 'Invoice',
        alignItemTo: 'left',
        width: 250
    },
    {
        title: 'Tenant',
        alignItemTo: 'left',
        width: 300
    },
    {
        title: 'Rent',
        alignItemTo: 'left',
        width: 200
    },
    {
        title: 'Overdue',
        alignItemTo: 'left',
        width: 250
    },
    {
        title: 'Invoice',
        alignItemTo: 'left',
        width: 250
    },
    {
        title: 'Paid',
        alignItemTo: 'left',
        width: 250
    },
    {
        title: 'Status',
        alignItemTo: 'left',
        width: 350
    },
    {
        title: 'Actions',
        alignItemTo: 'left',
        width: 150
    },
];

export const ELECTRICITY_TABLE_HEADERS = [
    {
        title: 'ID',
        alignItemTo: 'left',
        width: 50
    },

    {
        title: 'Name',
        alignItemTo: 'left',
        width: 150
    },
    {
        title: 'Consumed Electricity Unit',
        alignItemTo: 'left',
        width: 250
    },
];

export const ANNUAL_INCREMENT_TABLE_HEADERS = [
    {
        title: 'Increment Date',
        alignItemTo: 'left',
        width: 250
    },
    {
        title: 'Name',
        alignItemTo: 'left',
        width: 250
    },
    {
        title: 'Contact',
        alignItemTo: 'left',
        width: 250
    },
    {
        title: 'Entry Date',
        alignItemTo: 'left',
        width: 250
    },

    {
        title: 'Rent Amount',
        alignItemTo: 'left',
        width: 250
    },
    {
        title: 'Total Rent Amount',
        alignItemTo: 'left',
        width: 250
    },
];

export const PAYMENT_HISTORY_TABLE_HEADERS = [
    {
        title: 'Payment ID',
        alignItemTo: 'left',
        width: 250
    },
    {
        title: 'Invoice ID',
        alignItemTo: 'left',
        width: 250
    },
    {
        title: 'Service',
        alignItemTo: 'left',
        width: 250
    },
    {
        title: 'Title',
        alignItemTo: 'left',
        width: 250
    },

    {
        title: 'Paid At',
        alignItemTo: 'left',
        width: 250
    },
    {
        title: 'Amount',
        alignItemTo: 'left',
        width: 250
    },
];


/* ---------- Report ---------- */
export const REPORT_TABLE_HEADERS = [
    {
        title: 'Month - Year',
        alignItemTo: 'left',
        width: 250
    },
    {
        title: 'Total Rent',
        alignItemTo: 'left',
        width: 250
    },
    {
        title: 'Payment Received',
        alignItemTo: 'left',
        width: 250
    },
    {
        title: 'Overdue',
        alignItemTo: 'left',
        width: 250
    },
    {
        title: 'Actions',
        alignItemTo: 'left',
        width: 150
    },
];